module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_le_11_22_02_off.6f1f7dba.svg";